<div class="nsc-form-add-file">

    <button
      mat-raised-button
      id="addfile_button"
      for="input-files"
      type="button"
      class="nsc-form-actions__button"
      color="accent"
      [disabled]="uploadedFiles.length >= maxFileCount"
      (click)="fileInputClick()"> Add File <mat-icon>add</mat-icon>
    </button>
    
    <input 
      ng2FileSelect
      id="input-files"
      type="file"
      (change)="onChange($event)"
      [disabled]="uploadedFiles.length >= maxFileCount" 
      [accept]="'.' + allowedFileTypes.join(', .')"
      [uploader]="uploader"/>
    
    <div class="nsc-form-add-file__help">
      <mat-icon
        role="img"
        tabindex="0"
        aria-hidden="false"
        aria-label="Information about file requirements" 
        (click)="openDialog()"
        (keyup.enter)="openDialog()"
        (keyup.space)="openDialog()">info</mat-icon>
    </div>
    <span role="alert"  aria-live="assertive"  [attr.aria-label]="removeStatus"></span>
  </div>
  <div *ngIf="uploadedFiles.length > 0">
   
    <mat-table #table [dataSource]="dataSource">

      <ng-container matColumnDef="itemName">
        <mat-header-cell *matHeaderCellDef>File</mat-header-cell>
        <mat-cell *matCellDef="let uploadedFile" aria-label="file">  {{ uploadedFile.originalFileItem.file.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="itemStatus">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let uploadedFile" role="alert" aria-live="assertive">
          <div  ></div>
          <span [attr.aria-label]=" uploadedFile.originalFileItem.file.name" *ngIf="!uploadedFile.originalFileItem.isSuccess && !uploadedFile.originalFileItem.isError && !uploadedFile.originalFileItem.isCancel && !uploadedFile.originalFileItem.isUploading">Pending  </span>
          <span [attr.aria-label]=" uploadedFile.originalFileItem.file.name" *ngIf="uploadedFile.originalFileItem.isSuccess && (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status !== 'fail')">Uploaded </span>
          <span [attr.aria-label]=" uploadedFile.originalFileItem.file.name" class="mat-error" *ngIf="(uploadedFile.originalFileItem.isError || (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'fail')) && !uploadedFile.originalFileItem.isUploading">Error </span>
          <span [attr.aria-label]=" uploadedFile.originalFileItem.file.name" *ngIf="uploadedFile.originalFileItem.isCancel">Cancelled </span>
          <span [attr.aria-label]=" uploadedFile.originalFileItem.file.name" *ngIf="uploadedFile.originalFileItem.isUploading">Uploading...  </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="itemSize">
        <mat-header-cell *matHeaderCellDef>Size</mat-header-cell>
        <mat-cell *matCellDef="let uploadedFile">
          {{ roundFileSizeValue(uploadedFile.originalFileItem.file.size) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="itemButtons">
        <mat-header-cell *matHeaderCellDef>Remove</mat-header-cell>
        <mat-cell *matCellDef="let uploadedFile"  role="alert" aria-live="assertive">
          <button *ngIf="(uploadedFile.originalFileItem.isError || uploadedFile.originalFileItem.isCancel || (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'fail')) && !uploadedFile.originalFileItem.isUploading" mat-icon-button (click)="retryFileClick(uploadedFile)">
            <mat-icon>replay</mat-icon>
          </button>
          <button  mat-icon-button   (click)="removeFileClick(uploadedFile)"aria-label="Remove">
            <mat-icon>cancel</mat-icon>
          </button>
        
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsToDisplay" tabindex="0"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay;" tabindex="0"></mat-row>

    </mat-table>
   

    <nsc-spacer size="sm"></nsc-spacer>

    <div *ngIf="uploader.isUploading">
      <nsc-spacer size="md"></nsc-spacer>
      <div class="mat-subheading-1">Upload progress:</div>
      <div class="progress">
        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
      </div>
    </div>
  </div>
